
import { combineReducers } from 'redux';

import measure from './measure';

export default combineReducers({
    measure
});
